"use client"

import { useState } from "react"
import { Menu, X, HelpCircle } from "lucide-react"
import { Button } from "@/components/ui/button"

interface MobileMenuProps {
  onHelpOpen: (open: boolean) => void
}

export default function MobileMenu({ onHelpOpen }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  return (
    <div className="relative z-[999]">
      {/* Hamburger button */}
      <Button
        variant="outline"
        size="icon"
        onClick={toggleMenu}
        className="md:hidden bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 shadow-sm"
        aria-label="Menu"
      >
        {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
      </Button>

      {/* Desktop help button - visible on md and up */}
      <div className="hidden md:block">
        <Button
          variant="outline"
          onClick={() => onHelpOpen(true)}
          className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 shadow-sm flex items-center gap-2"
        >
          <HelpCircle className="h-4 w-4" />
          <span>Help</span>
        </Button>
      </div>

      {/* Mobile menu - slides in from the top */}
      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg overflow-hidden z-[1000] border border-gray-200">
          <div className="p-2 space-y-2">
            <div onClick={closeMenu}>
              <Button
                variant="ghost"
                onClick={() => {
                  onHelpOpen(true)
                  closeMenu()
                }}
                className="w-full justify-start text-left"
              >
                <HelpCircle className="h-4 w-4 mr-2" />
                <span>Help</span>
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
